let UTILS = require("../libs/utils.js");
const crypto = require("crypto-browserify");
var v6659;
var v6660;
module.exports = {
  id: "point",
  name: "Hardpoint",
  sub: "Attack the Objective",
  alias: "point",
  description: "Follow the target and control the area. The longer you stay, the more points you and your team make. Location changes every minute.",
  descriptionLang: "game.mode.point.description",
  endStats: ["sid", "name", "score", "kills", "deaths", "objective", "dmg", "reward"],
  leaderStats: ["score", "objective", "kills"],
  objective: true,
  teams: true,
  gameStart: function (p7903) {
    p7903.activeObjective = -1;
    p7903.nextObjective(null, true);
  },
  onKill: function (p7904, p7905, p7906, p7907) {
    if (!p7904.isSandbox && p7907 && p7907 != p7906 && p7904.isPubType()) {
      var v6661 = p7906.lastGround && !p7906.onGround;
      var vO202 = {
        x: v6661 ? p7906.lastGround.x : p7906.x,
        y: v6661 ? p7906.lastGround.y : p7906.y,
        z: v6661 ? p7906.lastGround.z : p7906.z
      };
      var v6662 = crypto.randomBytes(4).readUInt32LE() / 4294967296;
      v6662 = (v6662 * 100).round(2);
      if (v6662 <= 0.015) {
        p7904.dropSpawnable(18, p7906, null, vO202);
      }
    }
  },
  update: function (game, p7909, p7910) {
    if (game.map.manager.objectives.length && game.waitTimers && game.waitTimers[0].contTime && (game.objectiveTimer -= p7910, game.objectiveTimer <= 0)) {
      game.objectiveTimer = 1500;
      for (var vLN01052 = 0; vLN01052 < game.map.manager.objectives.length; ++vLN01052) {
        v6659 = game.map.manager.objectives[vLN01052];
        if (v6659 && v6659.uid == game.activeObjective) {
          for (var vLN01051 = 0; vLN01051 < game.players.list.length; ++vLN01051) {
            v6660 = game.players.list[vLN01051];
            if (v6660.active && v6660.collides(v6659)) {
              game.players.score(v6660, game.mode && game.mode.objScore ? game.mode.objScore : 10, 2);
            }
          }
        }
      }
      if (!game.notWinnable && game.teamScores[1] != game.teamScores[2] && game.isComp && (game.teamScores[1] || game.teamScores[2])) {
        var v6663 = (game.gameTimer || 0) / 1000;
        var v6664 = Math.floor(v6663 / 1.5);
        var v6665 = game.config.tmSize + 1;
        var v6666 = v6664 * (game.mode && game.mode.objScore ? game.mode.objScore : 10) * v6665;
        var v6667 = (game.teamScores[1] || 0) > (game.teamScores[2] || 0) ? 2 : 1;
        var v6668 = (game.teamScores[1] || 0) > (game.teamScores[2] || 0) ? 1 : 2;
        if (!((game.teamScores[v6667] || 0) + v6666 >= (game.teamScores[v6668] || 0))) {
          game.notWinnable = true;
          for (var vLN01052 = 0; vLN01052 < game.players.list.length; ++vLN01052) {
            v6659 = game.players.list[vLN01052];
            v6659.send("chi", -1, null, v6659.team == v6667 ? "modes.round.loss" : "modes.round.win", 2, "#ff0000");
          }
          game.endGame();
        }
      }
    }
  }
};